import { gql } from '@apollo/client';

export const GET_SCORECARD = gql`
  query GetScoreCardConfiguration {
    scoreCard {
      accountId
      financeProgramId
      structure
      createdDateTime
      modifiedDateTime
      prescreenCriteria {
        active
        accountId
        jsonCriteria
        prescreenCriteriaId
      }
    }
  }
`;

export const CREATE_CREDIT_TIERS_RESULTS = gql`
  mutation CreateCreditTiersResults($input: [CreateCreditTiersResultInput]!) {
    createCreditTiersResults(input: $input) {
      creditTiersResultId
      vendorOpportunityId
      prescreenCriteriaId
      financeProgramId
      runtimeInput
      runtimeOutput
      result
      highestTierPassed
      highestTierColor
      createdDateTime
      modifiedDateTime
    }
  }
`;
